import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import LANGUAGES_CONTROLLER, {DEFAULT_LANGUAGE_STRINGS}  from '../../controllers/languages';
import { SAlert } from '@avalara/skylab-sdk/react';

import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('ALERT_BOX', LOG_LEVELS.DEBUG);

class AlertBox extends React.Component {

    render() {
        log.debug('render(): ', this.props);
        
        let {
            show,
            messageKey,
            messageParams,
            onClose,
            languages
        } = this.props;

        if(!show || _.isEmpty(messageKey)) {
            return null;
        }

        const message = LANGUAGES_CONTROLLER.format(languages, messageKey, messageParams);

        return (
            <SAlert 
                status="info" 
                role="alert" 
                onS-dismiss={onClose}
            >
                <span>{message}</span>
            </SAlert>
        );
    }
}


AlertBox.defaultProps = {
    show: false,
    messageKey: '',
    messageParams: [],
    onClose: ()=>{}
}

function mapStateToProps(state, props) {
    return {
        languages: props.languages || (state.languages && state.languages.data) || DEFAULT_LANGUAGE_STRINGS
    };
}

export default connect(mapStateToProps)(AlertBox);
  